import React from "react";
import { SvgIcon } from "@mui/material";
import styles from "../../icons/iconStyles";

const CameraIcon = ({ color }: any) => {
  const styles = {
    icon: {
      width: 60,
      height: 50
    }
  }

  return (
    <SvgIcon style={styles.icon}>
      <svg width="60" height="50" viewBox="0 0 60 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M37.9589 29.2441C37.9589 33.6425 34.3984 37.2031 30 37.2031C25.6016 37.2031 22.0411 33.6425 22.0411 29.2441C22.0411 24.8458 25.6016 21.2852 30 21.2852C34.3984 21.2852 37.9589 24.8458 37.9589 29.2441ZM54.2464 9.29752C57.425 9.29752 60 11.8725 60 15.0511V30.1312V42.9197C60 46.3078 57.2526 49.0552 53.8645 49.0552H6.13552C2.74743 49.0552 0 46.3078 0 42.9197V30.1189V15.0511C0 11.8725 2.57495 9.29752 5.75359 9.29752H17.2608L17.8029 7.00594C18.6283 3.45768 21.7947 0.944336 25.4415 0.944336H34.5708C38.2177 0.944336 41.384 3.45768 42.2094 7.00594L42.7392 9.29752H54.2464ZM12 17.6014C12 16.0121 10.7064 14.7185 9.11704 14.7185C7.5154 14.7185 6.22177 16.0121 6.22177 17.6014C6.22177 19.1907 7.5154 20.4844 9.10472 20.4844C10.7064 20.4967 12 19.2031 12 17.6014ZM44.193 29.2441C44.193 21.4084 37.8357 15.0511 30 15.0511C22.1643 15.0511 15.807 21.4084 15.807 29.2441C15.807 37.0799 22.1643 43.4371 30 43.4371C37.8357 43.4371 44.193 37.0799 44.193 29.2441Z"
          fill={color || "#DDDDDD"}
        />
      </svg>
    </SvgIcon>
  );
};

export default CameraIcon;